import { useEffect, useState } from "react";
import { findAllOrderListLiveGroupByClientEvent } from "../../_events/order_list_view/find.event";
import { message } from "antd";
import { useQuery } from "../../_utils/url_query_hook";

export const useLiveClientOrders = () => {

    const [ loading, setLoading ] = useState(false);
    const [ data, setData ] = useState(null);
    const query = useQuery();

    useEffect(() => {
        setLoading(true);
        findAllOrderListLiveGroupByClientEvent(query.get('client'))
        .then(json => {
            setLoading(false);
            setData(json.data);
        })
        .catch(err => {
            setLoading(false);
            message.error(err.message);
        });
    }, []);
    
    return {
        data, loading
    };
}